<template>
    <div class="p-grid p-fluid dashboard" id="modal">
        <div class="p-fluid">
            <br>
            <div class="p-field p-grid">
                <div class="row p-col-12 p-md-4">
                    <label for="lecturaanterior" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Lectura anterior: </label>
                    <div class="p-col-12 col-md-10">
                        <InputText id="lecturaanterior" type="text" v-model="datos.lecturaactual" />
                    </div>
                </div>
                <div class="row p-col-12 p-md-4">
                    <label for="lecturaactual" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Lectura actual: </label>
                    <div class="p-col-12 col-md-10">
                        <InputText id="lecturaactual" type="text" v-model="lectura" />
                    </div>
                </div>
                <div class="row p-col-12 p-md-4">
                    <label for="consumo" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Consumo: </label>
                    <div class="p-col-12 col-md-10">
                        <InputText id="consumo" type="text" disabled v-model="datos.consumo" />
                    </div>
                </div>
                <div class="row p-col-12 p-md-4">
                    <label for="consumo" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Consumo mínimo: </label>
                    <div class="p-col-12 col-md-10">
                        <InputText id="consumo" type="text" v-model="consumominimo" />
                    </div>
                </div>
                <div class="row p-col-12 p-md-4">
                    <label for="lectura" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Imprimir planilla: </label>
                    <div class="p-col-12 col-md-10">
                        <Checkbox id="chk" v-model="imprimirPlanilla" :binary="true" />
                    </div>
                </div>
            </div>
            <div class="p-field p-col-12">
                <Button label="Grabar" icon="pi pi-save" style="width:110px;margin-right:10px" class="p-button-primary" @click="grabarRegistro()" />
                <Button label="Salir" icon="pi pi-times" style="width:110px;margin-right:10px" class="p-button-warning p-mr-2" @click="cerrarMod()" />
            </div>
        </div>
        <DialogProgreso
            :showProgreso="showProgreso"
            :titulo="mensajeCargando">
        </DialogProgreso>
    </div>
</template>

<script>
import PlanillaService from "../../../service/administracion/PlanillaService";
import DialogProgreso from "../../componentesglobales/DialogoProgreso.vue";
import Swal from 'sweetalert2';
export default {
    name: 'RegistroPlanilla',
    props: {
        cliente:{
            type: Object,
            default: null,
        },
        mes:{
            type: Object,
            default: null,
        },
        anio:{
            type: Object,
            default: null,
        },
        cerrarModal: Function
    },
    data(){
        return{
            datos: {},
            lectura: null,
            consumominimo: null,
            showProgreso: null,
            mensajeCargando: null,
            imprimirPlanilla: true
        }
    },
    planillaService: null,
    created() {
        this.planillaService = new PlanillaService();
    },
    mounted() {
        this.cargarDatosIniciales();
    },
    components: {
		'DialogProgreso': DialogProgreso
	},
    destroyed(){
    },
    methods:{
        cargarDatosIniciales(){
            Swal.fire({
				title: 'Cargando...',
				html: 'por favor, espere!...',
				allowOutsideClick: false,
				didOpen: () => {
					Swal.showLoading()
				}
			});
            this.planillaService.consultarLecturasCliente(this.anio.id, this.mes.id, this.cliente.id).then( response => {
                Swal.close();
                console.log("datos", response)
                this.datos = response.data;
                this.showProgreso = false;
            }).catch( error => {
                Swal.close();
                console.log(error);
            });
        },

        grabarRegistro(){
            if(this.lectura == null || this.lectura == undefined || this.lectura == ""){
                Swal.fire({ position: 'center', title: 'Advertencia!', text: "Debe registrar lectura", icon: 'warning', showConfirmButton: true, timer: 6000 });
                return;
            }
            if(this.lectura < this.datos.lecturaactual){
                Swal.fire({ position: 'center', title: 'Advertencia!', text: "Lectura ingresada no debe ser menor a la lectura anterior", icon: 'warning', showConfirmButton: true, timer: 6000 });
                return;
            }
            if(this.lectura == this.datos.lecturaactual){
                if(this.consumominimo == null || this.consumominimo == "" || this.consumominimo == undefined){
                    Swal.fire({ position: 'center', title: 'Advertencia!', text: "Debe registrar consumo minimo", icon: 'warning', showConfirmButton: true, timer: 6000 });
                    return;
                }
            }
            let user = JSON.parse(localStorage.getItem('user'));
            Swal.fire({ title: 'Grabar datos', text: "Esta seguro de realizar el proceso" , icon: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Si', cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: 'Cargando...',
                        html: 'por favor, espere!...',
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading()
                        }
                    });
                    let planilla = {
                        lectura: this.lectura,
                        idcliente: this.cliente.id,
                        idanio: this.anio.id,
                        anio: this.anio.anio,
                        idmes: this.mes.id,
                        mes: this.mes.mes,
                        lecturaanterior: this.datos.lecturaactual,
                        lecturaactual: this.lectura,
                        consumominimo: this.consumominimo,
                        usuario: user.usuario
                    }
                    this.planillaService.grabarPlanilla(planilla).then( () => {
                        Swal.close();
						Swal.fire({ position: 'center', customClass: { container: 'my-swal' }, title: 'Correcto!', text: "Grabado correctamente", icon: 'success', showConfirmButton: true, timer: 6000 });
                        this.imprimirPlanillaCliente();
                        this.cerrar();
					}).catch( error => {
                        Swal.close();
						console.log(error);
						Swal.fire({ position: 'center', title: 'Advertencia!', text: "Error al grabar", icon: 'warning', showConfirmButton: true, timer: 6000 });
					});
                }
            });
        },

        imprimirPlanillaCliente(){
            if(this.imprimirPlanilla == true){
                Swal.fire({
                    title: 'Generando planilla...',
                    html: 'por favor, espere!...',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                });
                this.planillaService.imprimirPlanilla(this.cliente.id,this.anio.id, this.mes.id).then(response => {
                    Swal.close();
                    var headers = response.headers;
                    var blob = new Blob([response.data],{type:headers['content-type']});
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "Planilla-" + this.cliente.cedula + "-" + this.anio.anio + "-" + this.mes.mes;
                    link.click();
                    this.showProgreso = false;
                })
                .catch(() => {
                });
            }
		},

        cerrar(){
            this.$emit('cerrarModal',this.cliente);
        },

        cerrarMod(){
            this.$emit('cerrarModal',null);
        }
    },

    filters: {
        dosDecimales: function(value) {
            if(value == null || value == undefined) return "";
            value = value.toFixed(2)
            return value;
        },
    }
}
</script>